export default "__VITE_ASSET__z2eJpV2$__"